import React from "react";

const toSlug = (text) =>
  text
    .toLowerCase() // lowercase
    .trim() // remove leading/trailing spaces
    .replace(/[^a-z0-9]+/g, "-") // replace spaces & non-alphanumerics with '-'
    .replace(/^-+|-+$/g, ""); // remove leading/trailing hyphens

const toTitleCase = (text) => {
  if (!text) return "";

  const raw =
    typeof text === "string"
      ? text
      : text?.props?.children
      ? text.props.children
      : String(text);

  return raw
    .toLowerCase()
    .split(" ")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

export { toSlug, toTitleCase };
